import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Badge,
  useMediaQuery
} from '@mui/material';
import {
  ShoppingCart as CartIcon,
  MoreVert as MoreIcon,
  Menu as MenuIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

interface AppHeaderProps {
  cartItemCount: number;
  onCartOpen: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ cartItemCount, onCartOpen }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ px: { xs: 1, md: 2 } }}>
        {/* No sidebar toggle */}
        
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <Typography variant="h6" component="div" sx={{ 
            fontWeight: 'bold',
            fontSize: { xs: '1rem', md: '1.25rem' }
          }}>
            {isMdUp ? 'TALKIN TACOS - AI-Powered POS System' : 'TALKIN TACOS'}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 } }}>
          {isMdUp && (
            <>
              <Button color="inherit" endIcon={<MoreIcon />}>
                More
              </Button>
              <Button color="inherit">
                Sign in
              </Button>
            </>
          )}
          {isMdUp && (
            <IconButton color="inherit" onClick={onCartOpen}>
              <Badge badgeContent={cartItemCount} color="error">
                <CartIcon />
              </Badge>
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
